import type { Routes } from '@angular/router';
import { AuthGuard } from './shared/guard/auth.guard';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('@components/site/layout/layout.component').then((c) => c.LayoutComponent),
        data: {
            scrollPosition: 'top',
        },

        children: [
            {
                path: '',
                loadComponent: () => import('./pages/site/home/home.component').then((c) => c.HomeComponent),
                data: {
                    scrollPosition: 'top',
                },
            },

            {
                path: 'contato',
                loadComponent: () => import('./pages/site/contact/contact.component').then((c) => c.ContactComponent),
                data: {
                    scrollPosition: 'top',
                },
            },
            {
                path: 'politica-de-privacidade',
                loadComponent: () =>
                    import('./pages/site/legal/privacy/privacy.component').then((c) => c.PrivacyComponent),
                data: {
                    scrollPosition: 'top',
                },
            },
            {
                path: 'politica-de-cookies',
                loadComponent: () =>
                    import('./pages/site/legal/cookies/cookies.component').then((c) => c.CookiesComponent),
                data: {
                    scrollPosition: 'top',
                },
            },
            {
                path: 'termos-de-uso',
                loadComponent: () => import('./pages/site/legal/terms/terms.component').then((c) => c.TermsComponent),
                data: {
                    scrollPosition: 'top',
                },
            },
        ],
    },
    {
        path: 'termo-assinado',
        loadComponent: () => import('./pages/site/signed/signed.component').then((c) => c.SignedComponent),
        data: {
            scrollPosition: 'top',
        },
    },
    {
        path: 'planos',
        loadComponent: () => import('./pages/site/plans/plans.component').then((c) => c.PlansComponent),
    },
    {
        path: 'assinar-termo/:id',
        loadComponent: () =>
            import('./pages/admin/signature/embbedded/embbedded.component').then((c) => c.EmbbeddedSignComponent),
    },
    {
        path: 'baixar-termo/:id',
        loadComponent: () =>
            import('./pages/admin/signature/download/download.component').then((c) => c.DownloadTermComponent),
    },
    {
        path: 'revisar-termo',
        loadComponent: () =>
            import('./pages/admin/signature/patient/revision/revision.component').then((c) => c.RevisionComponent),
    },
    {
        path: 'terms/:id/sign',
        loadComponent: () =>
            import('./pages/admin/signature/term-signing/term-signing.component').then((c) => c.TermSigningComponent),
    },
    {
        path: 'terms/:id/success',
        loadComponent: () =>
            import('./pages/admin/signature/term-success/term-success.component').then((c) => c.TermSuccessComponent),
    },
    // {
    //     path: 'assinar-termo-medico',
    //     loadComponent: () => import('./pages/admin/signature/doctor/doctor.component').then((c) => c.DoctorComponent),
    // },
    {
        path: 'imagem-do-documento',
        loadComponent: () =>
            import('./pages/admin/signature/mobile-pic/mobile-pic.component').then((c) => c.MobilePicComponent),
    },
    {
        path: 'admin/auth',
        loadChildren: () => import('./pages/admin/auth/auth.routes').then((r) => r.AUTH_ROUTES),
    },
    {
        path: 'admin',
        loadComponent: () => import('./layout/layout.component').then((c) => c.LayoutComponent),
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./pages/admin/dashboard/dashboard.component').then((c) => c.DashboardComponent),
            },
            {
                path: 'procedimentos',
                loadComponent: () =>
                    import('./pages/admin/procedures/procedures.component').then((c) => c.ProceduresComponent),
            },
            {
                path: 'especialidades',
                loadComponent: () =>
                    import('./pages/admin/specialties/specialties.component').then((c) => c.SpecialtiesComponent),
            },
            {
                path: 'termos-de-consentimento',
                loadComponent: () => import('./pages/admin/terms/terms.component').then((c) => c.TermsComponent),
            },
            {
                path: 'medicos',
                loadComponent: () => import('./pages/admin/doctors/doctors.component').then((c) => c.DoctorsComponent),
            },
            {
                path: 'pacientes',
                loadComponent: () => import('./pages/admin/patients/patients.component').then((c) => c.PatientsComponent),
            },
            {
                path: 'conteudo',
                loadComponent: () => import('./pages/admin/content/content.component').then((c) => c.ContentComponent),
            },
            {
                path: 'conta',
                loadComponent: () => import('./pages/admin/account/account.component').then((c) => c.AccountComponent),
            },
            {
                path: 'suporte',
                loadComponent: () => import('./pages/admin/support/support.component').then((c) => c.SupportComponent),
            },
            {
                path: 'admins',
                loadComponent: () => import('./pages/admin/admins/admins.component').then((c) => c.AdminsComponent),
            },
            {
                path: 'clientes',
                loadComponent: () => import('./pages/admin/clients/clients.component').then((c) => c.ClientsComponent),
            },
            {
                path: 'relatorios',
                loadComponent: () => import('./pages/admin/reports/reports.component').then((c) => c.ReportsComponent),
            },
        ],
    },
];
